import React from 'react';
import './TechContainer.css';

const TechContainer = (props) => {
        const { tec } = props.tec;
        return (
                <div className="d-inline-block ms-2 mt-2 tec">{tec}</div>
        );
};

export default TechContainer;